module.exports = __webpack_public_path__ + "static/media/Avatars_Male-03.df1e2618.png";